// extracted by mini-css-extract-plugin
export default {"button":"SelectedSearches_button__tlfjy","heading":"SelectedSearches_heading__k9ulv","wrapper":"SelectedSearches_wrapper__tUa5h","searches":"SelectedSearches_searches__jAmP-"};